module.exports = __webpack_public_path__ + "img/coming-soon.cbe7222a.svg";